import type { TypedMyHotelAdditionalData } from './-MyHotelAdditionalData';
import RawMyHotelAccess from './MyHotelAdditionalData.vue';
export * from './-MyHotelAdditionalData';

export const MyHotelAdditionalData = RawMyHotelAccess as typeof TypedMyHotelAdditionalData;
